import { render, staticRenderFns } from "./LegalAssistanceFaq.vue?vue&type=template&id=30c42821"
import script from "./LegalAssistanceFaq.vue?vue&type=script&lang=ts"
export * from "./LegalAssistanceFaq.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports